/** @format */

import React, { FC } from "react";
import { Col, Row } from "antd";
import styled from "styled-components";
import { TIntermittentSummary } from "../../../../redux-modules/declarations/maps/intermittentCommunications";
import { BaseColor, Colors } from "../../../../theme/maps/Colors";
import { UIText } from "../../../ui/Text";

export type TQuickView = "needs_action" | "scheduled" | "sent" | "cancellation_pending" | "all";

interface Props {
  summary?: TIntermittentSummary;
  active: TQuickView;
  onSelect: (view: TQuickView) => void;
}

/** Contatori in testa alla pagina: ognuno è anche un filtro rapido. */
export const SummaryCards: FC<Props> = ({ summary, active, onSelect }) => {
  const count = (status: string): number =>
    summary?.by_status.find(s => s.status === status)?.total ?? 0;

  const cards: { key: TQuickView; value: number; label: string; hint: string; alert?: boolean }[] = [
    {
      key: "needs_action",
      value: summary?.needs_action ?? 0,
      label: "Da gestire",
      hint: "richiedono un intervento",
      alert: (summary?.needs_action ?? 0) > 0,
    },
    { key: "scheduled", value: count("scheduled"), label: "In programma", hint: "partiranno in automatico" },
    { key: "sent", value: count("sent"), label: "Inviate", hint: "in attesa del controllo presenze" },
    {
      key: "cancellation_pending",
      value: count("cancellation_pending"),
      label: "In attesa di annullamento",
      hint: "annullamento automatico in arrivo",
    },
  ];

  return (
    <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
      {cards.map(c => (
        <Col key={c.key} xs={12} lg={6}>
          <StatCard
            role="button"
            active={active === c.key}
            onClick={(): void => onSelect(active === c.key ? "all" : c.key)}
            data-cy={`intermittent-card-${c.key}`}
          >
            <UIText type="secondary" style={{ fontSize: 13 }}>
              {c.label}
            </UIText>
            <Value alert={!!c.alert}>{summary ? c.value : "–"}</Value>
            <UIText type="secondary" style={{ fontSize: 12 }}>
              {c.hint}
            </UIText>
          </StatCard>
        </Col>
      ))}
    </Row>
  );
};

const StatCard = styled.div<{ active: boolean }>`
  background: white;
  border-radius: 7px;
  padding: 14px 18px;
  cursor: pointer;
  height: 100%;
  border: 1px solid ${(p): string => (p.active ? "" + BaseColor : "#f0f0f0")};
  box-shadow: ${(p): string => (p.active ? `0 0 0 1px ${BaseColor}` : "none")};
  transition: border-color 0.2s, box-shadow 0.2s;

  &:hover {
    border-color: ${BaseColor};
  }
`;

const Value = styled.div<{ alert: boolean }>`
  font-size: 28px;
  font-weight: 600;
  line-height: 1.3;
  color: ${(p): string => (p.alert ? Colors.red : "rgba(0, 0, 0, 0.85)")};
`;
